import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">关于我们</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">了解91吃瓜爆料</p>
        <div className="max-w-[800px] mx-auto">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-8">
            {aboutData.content}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
            {aboutData.highlights.map((h) => (
              <div key={h.label} className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${h.icon} text-xl text-primary-600`}></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{h.label}</span>
                <span className="text-xs text-foreground-500">{h.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}